import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ErrorView } from '@americanexpress/commercial-ux-components';

const SystemError = () => (
  <ErrorView
    heading={<FormattedMessage id="systemError.heading" />}
    details={
      <span data-testid="error-details">
        <FormattedMessage id="systemError.details" />
      </span>
    }
    actionButton={false}
  />
);

export default SystemError;
